module.exports = __webpack_public_path__ + "static/media/SOTA QUASAR.ac368b39.png";